import styled from "styled-components";
import { theme } from "../../styles/theme";

export const BadgeContainer = styled.div`
    width: auto;
    height: 24px;
    /* Com o X, a direita fica mais estreita para o botao nao empurrar a pilula;
       so com texto, o padding volta a ser simetrico. */
    padding: ${props => (props.hasClose ? '4px 4px 4px 8px' : '5px 8px')};

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    border-radius: 10rem;
    background-color: ${props => props.colorBg || theme.colors.gray.Cinza_2};

    > img {
        width: 12px;
        height: auto;
    }

    > p {
        white-space: nowrap;
        text-align: center;
    }
`;

// Botao do X exibido quando IsClose. O dimensionamento da imagem fica aqui e nao
// na regra "> img" do container, porque esta img e neta dele.
export const CloseButton = styled.button`
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
    padding: 0;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    border: none;
    background: transparent;
    line-height: 1;
    cursor: pointer;

    > img {
        width: 100%;
        height: auto;
    }
`;
